import * as React from "react";
import { isEmpty as _isEmpty, get as _get } from "lodash"
import * as moment from "moment";
import { LinkContainer } from "react-router-bootstrap";
import { NavItem } from "react-bootstrap";
import { default as AppUtils, EpochConstants } from "../../utils/AppUtils";
import { RouteUtils } from "../../routes";
import {AppConstants, AppDisplayInfos, ConsultationStatusConstant, SubServiceType} from "../../utils/AppConstants"
import ConsultationUtils from "../../utils/ConsultationUtils";

const PatientConsultationCard = (props: any) => {
    let tags: string[] = []
    let consultingDoctorId = props.consultation && props.consultation.doctor ? props.consultation.doctor.id : "";
    let loggedInDoctorId = props.doctorId;
    let consultation = props.consultation;
    let consultationDetailUrl = RouteUtils.getPatientConsultationDetailsUrl(consultation && consultation.patient && consultation.patient.id, consultation.id);
    let absoluteTimeToDisplay = moment(consultation.startTime).format("h:mm a");

    /* Appointment Status Handling */
    const isStartActionAllowed = AppUtils.isStartActionAllowedForConsultation(props.consultation);
    let buttonText = AppUtils.isDefined(consultation.status)
        ? consultation.status
            .split("_")
            .map((word: string) => word.charAt(0).toUpperCase() + word.substr(1).toLowerCase())
            .join(" ")
        : "Completed";
    let consultationTypeCls = isStartActionAllowed ? "start-consultation" : "completed-consultation";

    let consultationTitle = `Consultation with ${!_isEmpty(consultation.doctor.prefix) ? consultation.doctor.prefix + " " : ""}${consultation.doctor.name}`;

    /* Consultation Mode Handling */
    let consultationModeCls = "offline-consultation";
    let consultationModeText = AppConstants.ConsultationModes.OFFLINE.display
    if (consultation.consultationProduct.consultationMode === AppConstants.ConsultationModes.ONLINE.id) {
        consultationModeCls = "online-consultation";
        consultationModeText = AppConstants.ConsultationModes.ONLINE.display
    }

    /* Upcoming Consultation Status */
    let upcomingConsultationText = AppDisplayInfos.UPCOMING_CONSULTATION_INFO;
    let isUpComingStartBtnEnabled = loggedInDoctorId === consultingDoctorId && isStartActionAllowed;
    let upComingStartBtnCls = isStartActionAllowed ? "enabled" : "disabled";
    let startConsultationUrl: string = isStartActionAllowed ? RouteUtils.getOngoingConsultationUrl(consultation.patient.id, consultation.id) : null;

    const handleStartBtn = (e: any) => {
        e.stopPropagation();
        RouteUtils.navigateToHrefUrl(e, startConsultationUrl);
        return false
    }
    const isMobile: boolean = AppUtils.getIsMobile();

    // insert tags if any
    if (_get(props.consultation, "consultationSellableProduct.consultationProduct.subServiceType", "") === SubServiceType.COUPLE_THERAPIST) {
        tags.push("Couple")
    }
    return (
        <LinkContainer to={consultationDetailUrl}>
            <NavItem>
                <div className={"consultation-card " + consultationTypeCls + " " + consultationModeCls}>
                    {
                        !_isEmpty(tags) && <div className={"cons-tags-container"}>
                            {
                                tags.map((tag: string) => {
                                    return <span className={"tag"}>{tag}</span>
                                })
                            }
                        </div>
                    }
                    {!isMobile &&
                        <div className="card-top-panel">
                            <div className="card-info-panel">
                                <div className="consultation-time">
                                    {absoluteTimeToDisplay}
                                </div>
                                <div className="consultation-mode">
                                    {consultationModeText}
                                </div>
                            </div>
                            <div className="card-main-content">
                                {consultationTitle}
                            </div>
                            <div className="card-action-panel">
                                <div className="consultation-status-btn">
                                    {buttonText}
                                </div>
                            </div>
                        </div>
                    }
                    {isMobile &&
                        <React.Fragment>
                            <div className="card-top-panel">
                                <div className="card-info-panel">
                                    <div className="consultation-time">
                                        {absoluteTimeToDisplay && absoluteTimeToDisplay}
                                    </div>
                                    <div>|</div>
                                    <div className="consultation-mode">
                                        {consultationModeText && consultationModeText}
                                    </div>
                                </div>
                                
                                <div className="card-action-panel">
                                    <div className="consultation-status-btn">
                                        <span className="status-dot"></span>
                                        {buttonText && buttonText.split(" ") && buttonText.split(" ").reverse()[0]}
                                    </div>
                                </div>
                                {/* <div className="card-main-content">
                                {consultationTitle}
                            </div>
                            <div className="card-action-panel">
                                <div className="consultation-status-btn">
                                    {buttonText}
                                </div>
                            </div> */}
                            </div>
                            <div className="card-main-content">
                                {consultationTitle}
                            </div>
                        </React.Fragment>
                    }
                    {isUpComingStartBtnEnabled && <div className="start-appointment-container">
                        {!isMobile &&
                            <div className="start-appointment-info">{upcomingConsultationText}</div>
                        }
                        <div>
                            <a onClick={handleStartBtn}>
                                <input className={"consultation-start-btn " + upComingStartBtnCls} type="button" value="Start" disabled={!isUpComingStartBtnEnabled} />
                            </a>
                        </div>
                    </div>}

                    {!isUpComingStartBtnEnabled && <div className="start-appointment-container">
                        <div>
                            <a href="consultationDetailUrl">
                                <input className={"consultation-start-btn enabled"} type="button" value="View More" />
                            </a>
                        </div>
                    </div>}
                </div>
            </NavItem>
        </LinkContainer>

    )
}

export default PatientConsultationCard;

